export default function MistralLogo() {
  return (
    <svg width="16" height="16" viewBox="0 0 256 256">
      <rect x="47.5254" y="48.0029" width="32.1358" height="32.1386" fill="#FFD800" />
      <rect x="47.5254" y="79.7451" width="64.4606" height="32.1386" fill="#FFAF00" />
      <rect x="143.9" y="79.7451" width="64.4606" height="32.1386" fill="#FFAF00" />
      <rect x="47.5254" y="143.646" width="32.1358" height="32.1386" fill="#FA500F" />
      <path d="M79.6611 207.997H15.416V175.858H79.6611V207.997ZM111.817 207.997H79.6816V175.858H111.817V207.997Z" fill="#E10500" />
      <rect x="176.275" y="48.0029" width="32.1358" height="31.7605" fill="#FFD800" />
      <rect x="176.275" y="143.646" width="32.1358" height="32.1386" fill="#FA500F" />
      <rect x="111.947" y="143.646" width="32.1358" height="32.1386" fill="#FA500F" />
      <rect x="47.5254" y="111.903" width="160.868" height="32.1386" fill="#FF8205" />
      <path d="M208.427 207.997H144.182V175.858H208.427V207.997ZM240.583 207.997H208.447V175.858H240.583V207.997Z" fill="#E10500" />
    </svg>
  )
}
